module.exports = __webpack_public_path__ + "img/shipin.dadae569.png";